<!-- search  with term and object filters -->
<div class="rules-search-items">
  <label class="select-label" *ngIf="variable.description!=''">{{variable.description}}</label>
  <div class="rules-search-main">
    <div class="filtered-fields">
      <div class="selected-item" *ngFor="let sel of selected">
        <!-- class for not X botton [ngClass]="{'no-action':!multipleValues}" -->
        <span class="item-action"  [ngStyle]="{'border-color': sel.options.color}">
          <em>{{sel.description}}</em>
          <span title="Remove item" class="item-action-btn" (click)="removeItem(sel)">X</span>
        </span>
      </div>
    </div>
    <input #mySearchRulesTerm type="text" [placeholder]="placeholder" [ngModel]="term" [hidden]="!multipleValues && selected.length > 0"
      (ngModelChange)="onTermChanges($event)" />
  </div>
  <div class="rules-search-results" [hidden]="found != null && found.length == 0 && term == ''  || (!multipleValues && selected.length > 0)">
    <settings-rules-rule-form-helper-search-results
      [availableItems]="variableValues"
      [selected]="selected"
      (selectItem)="onSelectRuleItem($event)"
    ></settings-rules-rule-form-helper-search-results>
  </div>
</div>
    
